import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from 'src/app/vme-common.module';
import { VMEComponentsModule } from 'src/app/vme-components.module';
import { VmeDirectivesModule } from 'src/app/vme-directives.module';
import { VmePipesModule } from 'src/app/vme-pipes.module';
import { SupplierJobsInboxComponent } from './supplier-jobs-inbox.component';
import { TaskAndLocationContainerComponent } from './task-and-location-container.component';
import { MegaMenuModule } from 'primeng';
import { RedirectTermConditionGuard } from 'src/app/guards/redirect-term-condition.guard';
import { AlgoTravelPreferencesModule } from '../../../components/algo-travel-preferences/algo-travel-preferences.module';
import { ChecklistCategoryItemModule } from '../../../components/checklist-category-item/checklist-category-item.module';
import { JobGrabbedComponent } from '../../../components/travel-scheduler/job-grabbed/job-grabbed.component';
import { TravelSchedulerComponent } from '../../../components/travel-scheduler/travel-scheduler.component';

const routes: Routes = [
  { path: '', component: SupplierJobsInboxComponent, canActivate: [RedirectTermConditionGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierJobsInboxRoutingModule {}

@NgModule({
  imports: [
    SupplierJobsInboxRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    MegaMenuModule,
    AlgoTravelPreferencesModule,
    ChecklistCategoryItemModule,
    JobGrabbedComponent,
    TravelSchedulerComponent,
  ],
  declarations: [SupplierJobsInboxComponent, TaskAndLocationContainerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [TaskAndLocationContainerComponent],
})
export class SupplierJobsInboxModule {}
